import React from 'react'

const TapsHappyHourPl8 = (props) => {
    console.log(props)

    let tapBeers = props.tapMenu
    return(
        <div className="hh-taps-page">
        <div className="background-image">
            <div className="col-left">
                <div className="column pl1-taps-cans-pg-left">
                    <div className="taps-happyhour-container">
                    {props.happyHours 
                        ?   <>
                                {props.happyHours.map((promo, key) => (
                                   <div id={`hh-item-${key}`} className="hh-item">
                                   <div id={`happyhour-title-${key}`} className="happyhour-title">
                                       {promo.name.label}
                                   </div>
                                   <div id={`happyhour-description-${key}`} className="happyhour-description">
                                       {promo.description}
                                   </div>
                                   <div id={`hh-offers-${key}`} className="hh-offers">
                                       {promo.offers.map(offer => (
                                           <div>
                                               <div>{offer.offer}</div>
                                           </div>
                                       ))}
                                   </div>
                               </div>
                                ))}
                            </>

                        :   <>
                                loading...
                            </>
                    }
                    </div>
                </div>
            </div>
            <div className="col-right">
                <div className="column pl8-taps-hh-pg-right">
                    {tapBeers.length ? tapBeers.map(item => (
                        <div className="pl3-tap-item-page-new tap-item-print">
                                {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                <div className="pl1 print-item-line-two">{item.containers[0].name} • <span className="style-print pl1"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                        </div>
                    )): <>loading...</>}
                </div>
            </div>
        </div>
    </div>
    )
}
export default TapsHappyHourPl8